<template>
  <div class="mainPage">
    <div class="confirmHead">
      <div class="confirm" :class="{ 'active': tab===1 }">
        <span class="circle">1</span>
        <span>
          {{$t('mall_order_index.order_confirmation')}}<!--確認訂單  --></span>
      </div>
      <div class="payOrder" :class="{ 'active': tab===2 }">
        <span class="circle">2</span>
        <span>
          {{$t('mall_order_index.pay_order')}}<!-- 支付訂單 -->
        </span>
      </div>
      <div class="paySuccess" :class="{ 'active': tab===3 }">
        <span class="circle">3</span>
        <span>
          {{$t('mall_order_index.pay_success')}}<!-- 支付成功 -->
        </span>
      </div>
    </div>
    <div class="bottomBox">
      <div class="leftBox">
        <router-view v-on:tab="changeTab" :key="$route.fullPath"></router-view>
      </div>
      <div class="rightBox">
        <div>
          <div class="needHelp">
            <div class="header">
              <img :src="require('@/assets/img/order/ico_help.png')" alt="">
              <span class="title">
                {{$t('mall_order_index.need_help')}}<!-- 需要幫助嗎？ --></span>
            </div>
            <div class="helpDetail">
              {{$t('mall_order_index.contact_us')}}<!-- 您可以通過以下方式聯繫我們： -->
            </div>
            <div class="helpDetail">
              <div class="customerSer" style="font-size: 14px;">
                <div class="header" style="margin-top: 30px;padding-bottom: 12px;">
                  <img style="width: 18px;height: 18px;" :src="require('@/assets/img/order/ico_mobile.png')" alt="">
                  <span style="color:#1E1303;font-size: 14px;">
                    {{$t('mall_order_index.cs_hotline')}}<!-- 客服熱線 -->
                  </span>
                </div>
                <div class="phoneNum">(852) 2508-0998</div>
                <div class="phoneNum">
                  {{$t('mall_order_index.work_day')}}<!-- 客服工作日： --><br>
                  {{$t('mall_order_index.mon_sun')}}<!-- 逢星期一至星期五 早上10點到下午6點 --></div>
              </div>
              <div class="mailBox">
                <div class="header" style="margin-top: 30px;padding-bottom: 12px;">
                  <img style="width: 18px;" :src="require('@/assets/img/order/ico_email.png')" alt="">
                  <span style="color:#1E1303;font-size: 14px;">
                    {{$t('mall_order_index.office_email')}}<!-- 官方郵箱 -->
                  </span>
                </div>
                <div class="mail">info@jewellery-box.com</div>
              </div>
            </div>

          </div>

          <div class="header title" style="margin-top: 50px;margin-bottom: 30px;">
            {{$t('mall_order_index.shopping_promise')}}<!-- 搜飾盒購物承諾 -->
          </div>
          <div class="packageFree">
            <div class="packageFreePolicy">
              <img :src="require('@/assets/img/order/ico_subway.png')" alt="">
              <span>
                {{$t('mall_order_index.policy')}}<!-- 配送政策 -->
              </span>
            </div>
            <div class="helpDetail" style="margin-left: 35px;margin-bottom: 25px;margin-top: 10px;">
              {{$t('mall_order_index.policy_content')}}<!-- 產品準備好後，客戶服務人員聯繫您預約時間，免費到香港各地（除離島外）辦公室及各港鐵站進行交收 -->
            </div>
          </div>
          <div class="packageFree">
            <div class="packageFreePolicy">
              <img :src="require('@/assets/img/order/ico_cart.png')" alt="">
              <span>
                {{$t('mall_order_index.free_exchange')}}<!-- 無限次數換戴 -->
              </span>
            </div>
            <div class="helpDetail" style="margin-left: 35px;margin-bottom: 25px;margin-top: 10px;">
             {{$t('mall_order_index.exchange_content')}} <!-- 凡在搜飾盒購買鑲嵌鑽石產品，即可成為搜飾盒會員，享有會員無限次數換戴服務。全新珠寶，等價換戴 -->
            </div>
          </div>
        </div>
        <div class="bottomText">
          {{$t('mall_order_index.tips')}}<!-- *須受有關條款及細則約束，詳情請查看搜飾盒App，或向客戶服務人員聯絡。 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ConfirmOrder",
    components: {},
    data(){
      return{
        tab: 0,
      }
    },
    methods: {
      changeTab(tab) {
        this.tab = tab;
      }
    },
    mounted(){
    },
    created() {

    },
  }
</script>

<style scoped>
  .mainPage {
    width: 1200px;
    margin: 0 auto;
  }
  .bottomBox {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 50px;
  }

  .rightBox {
    width: 356px;
    height: 800px;
    /*border: 1px solid #ddd;*/
    -webkit-box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
    -moz-box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
    box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 30px;
    padding-right: 30px;
    color: #1E1303;
  }
  .rightBox .title {
    font-size: 16px;
  }
  .confirmHead {
    width: 100%;
    height: 50px;
    background-color: #1E1303;
    color: #7A7977;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 78px;
    margin-bottom: 30px;
    font-size: 18px;
  }
  .circle {
    display: inline-block;
    width: 23px;
    height: 23px;
    text-align: center;
    line-height: 1.3;
    /*background-color: #fff;*/
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    color: #7A7977;
    border: 1px solid #7A7977;
  }
  .active {
    color: #fff;
    border: none !important;
  }
  .active>.circle {
    background-color: #fff;
  }
  .confirm {
    margin-left: 95px;
  }
  .confirmHead>div {
    margin-right: 95px;
  }

  .addr>div>img {
    width: 12px;
    height: 15px;
    margin-right: 10px;
  }
  .firstBox>div>img {
    width: 12px!important;
    height: 15px!important;
    margin-right: 10px!important;
  }
  .addr>div>span {
    margin-right: 50px;
  }
  .addr>div>span:last-child {
    color: #3E3C39;
  }
  .leftBox {
    /*border: 1px solid #000;*/
    background-color: #fff;
    width: 804px;
    -webkit-box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
    -moz-box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
    box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
    padding: 30px 80px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    color: #5B5957;

  }
  .needHelp {
    padding-top: 30px;
    border-bottom: 1px solid #BBBBBB;
  }
  .header>img {
    width: 22px;
    margin-right: 10px;
  }
  .header{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 15px;
  }
  .helpDetail {
    color: #7A7977;
    font-size: 14px;
    margin-left: 30px;
  }
  .phoneNum {
    color: #5B5957;
    margin-left: 23px;
  }
  .workTime {
    margin-left: 23px;
    color: #979694;
  }
  .mailBox {
    font-size: 14px;
    color: #1E1303;
    margin-top: 30px;
    padding-bottom: 50px;
  }
  .mailHeader>img {
    width: 18px;
  }
  .mail {
    color: #5B5957;
    margin-left: 20px;
  }
  .packageFreePolicy {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .packageFreePolicy>img {
    width: 19px;
    margin-right: 10px;
  }
  .bottomText {
    margin-top: 78px;
    color: #9F9F9D;
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/views/viewHK/Order/Index.vue